import React from "react";

const OrderDisabledPopup = (props) => {
    return (
        <section class="overlay">
			<div class="overlay-window-container">
				<div class="overlay-window">
					<div class="overlay-content padding-0">
						<div class="overlay-header">
							<div class="overlay-header-title" dangerouslySetInnerHTML={{__html: props.htmlString}}></div>
						</div>
					</div>
					<div class="overlay-controls">
						<button onClick={props.close} class="button w-100">Close</button>
					</div>
				</div>
			</div>
		</section>
    )
}

export default OrderDisabledPopup;